import {action} from 'typesafe-actions';
import {SharedActionTypes} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const unselectServiceProviderGroup = () =>
    action(SharedActionTypes.UNSELECT_SERVICE_PROVIDER_GROUP);
export const logoutSuccess = () =>
    action(SharedActionTypes.LOGOUT_SUCCESS);
